import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IDict } from '../shared.interface';

@Component({
  selector: 'app-dialog-set-tag',
  templateUrl: './dialog-set-tag.component.html',
  styleUrls: ['./dialog-set-tag.component.scss']
})
export class DialogSetTagComponent implements OnInit {
  selected_channels_count: number;
  tags: IDict[];

  selected_tag: number = 0;
  tag_title: string;

  constructor(public dialogRef: MatDialogRef<DialogSetTagComponent>,
  @Inject(MAT_DIALOG_DATA) public data: { selected_channels_count: number; tags: IDict[] }) {
    this.selected_channels_count = data.selected_channels_count;
    this.tags = data.tags;
  }

  ngOnInit() {
  }

  set_tag(){
    let tag_title: string = (this.tag_title) ? this.tag_title.trim() : null;
    this.dialogRef.close({tag: tag_title, id: this.selected_tag});
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-set-tag/dialog-set-tag.component.ts